import { cx } from '@lastbrand/web-ui-styled-system/css'
import React from 'react'

import { transformImageSrc } from '@src/quince-components/src/atoms/image/image.utils'
import { OptionProp } from '@src/quince-site-pdp/src/atoms/optionSelector/OptionSelector.constant'

import {
  imageClass,
  imageLabelClass,
  imageLabelRoundClass,
  imageOptionWrapperClass,
  imageRoundInnerClass,
  redDotClass,
} from './image-option-ds.styles'
import { OptionContainerDS } from './option-container-ds'

const getOptionImageURL = (imgURL: string) => {
  imgURL = transformImageSrc(imgURL)
  // Normalize protocol-relative URLs (matches legacy ImageOption).
  const imageURL = new URL(imgURL.startsWith('http') ? imgURL : `https:${imgURL}`)
  /* eslint-disable i18next/no-literal-string -- URL query params for image resize, not user-facing */
  imageURL.searchParams.append('w', '48')
  imageURL.searchParams.append('h', '48')
  imageURL.searchParams.append('fm', 'webp')
  /* eslint-enable i18next/no-literal-string */
  return imageURL.toString()
}

type ImageOptionDSProps = {
  value: string
  displayName?: string
  imgURL?: string | null
  disabled?: boolean
  onChange?: (value: string) => void
  showRedDot?: boolean
} & Pick<OptionProp, 'isSelected' | 'isRound' | 'selectionSetId' | 'className'>

// Native radio + Panda label with SR-only swatch text; round vs rectangular via `isRound`.
export const ImageOptionDS = ({
  value,
  displayName,
  imgURL,
  isSelected,
  isRound,
  disabled,
  className,
  selectionSetId,
  onChange,
  showRedDot,
}: ImageOptionDSProps) => {
  return (
    <div className={imageOptionWrapperClass}>
      <OptionContainerDS
        value={value}
        displayName={displayName}
        selectionSetId={selectionSetId}
        isSelected={isSelected}
        srOnly
        disabled={disabled}
        labelClassName={cx(className, isRound ? imageLabelRoundClass : imageLabelClass)}
        onChange={onChange}
      >
        <img
          className={cx(imageClass, isRound && imageRoundInnerClass)}
          src={imgURL ? getOptionImageURL(imgURL) : undefined}
          // decorative: the sr-only label (srOnly above) already names the swatch; avoid double announce
          alt=""
        />
      </OptionContainerDS>
      {showRedDot ? <div className={redDotClass} /> : null}
    </div>
  )
}

const ImageOptionDSWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return (
    <ImageOptionDS
      value={optionValue.value}
      displayName={optionValue.displayName}
      imgURL={optionValue.imgURL}
      {...props}
    />
  )
}

export default ImageOptionDSWithOptionValue
